/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetOrgMembersOptions, GetOrgMembersResponses } from '../../models/GetOrgMembers'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get all members of the org.
 * @summary Get Org Members
 * {@link /org/members}
 */
export function getOrgMembers<ThrowOnError extends boolean = true>(options: Options<GetOrgMembersOptions, ThrowOnError> = {}): Promise<UnwrappedResult<GetOrgMembersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/org/members', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetOrgMembersResponses, ThrowOnError>>
}
